import { CategoryEnum } from 'libs/datalayer/src';
import { StepIds } from '../property-step/property-step-model';

export const SUB_CATEGORY_PROPERTY_NAME = 'subCategory';
export const LAST_SAVED_STEP_ID_PROPERTY_NAME = 'lastSavedStepId';

export const RENT_PROPERTIES_BY_STEP_ID: ReadonlyMap<StepIds, string> = new Map<
    StepIds,
    string
>([
    [StepIds.propertyInformation, 'propertyInformation'],
    [StepIds.propertyDescription, 'propertyDescription'],
    [StepIds.propertyPhotos, 'propertyPhotos'],
    [StepIds.propertyPromote, 'propertyPromote'],
    [StepIds.propertySummary, 'propertySummary']
]);

export const SALE_PROPERTIES_BY_STEP_ID: ReadonlyMap<StepIds, string> = new Map<
    StepIds,
    string
>([
    [StepIds.propertyInformation, 'propertyInformation'],
    [StepIds.propertyDescription, 'propertyDescription'],
    [StepIds.propertyPhotos, 'propertyPhotos'],
    [StepIds.propertyPromote, 'propertyPromote'],
    [StepIds.propertySummary, 'propertySummary']
]);

export const getPropertyNameByStepIdAndCategory = (
    s: StepIds,
    c: CategoryEnum
): string => {
    switch (c) {
        case CategoryEnum.residentialForRent:
            return RENT_PROPERTIES_BY_STEP_ID.get(s);
        case CategoryEnum.residentialForSale:
        case CategoryEnum.lifeStyle:
        case CategoryEnum.newHomesHouseAndLand:
        case CategoryEnum.newHomesNewApartment:
        case CategoryEnum.newHomesNewHouse:
        case CategoryEnum.newHomesNewTownhouseAndTerraced:
        case CategoryEnum.sectionsForSale:
        case CategoryEnum.rural:
            return SALE_PROPERTIES_BY_STEP_ID.get(s);
        default:
            return '';
    }
};

export const RENT_TITLES_BY_STEP_ID: ReadonlyMap<StepIds, string> = new Map<
    StepIds,
    string
>([
    [StepIds.propertyInformation, 'Property Information'],
    [StepIds.propertyDescription, 'Property Description'],
    [StepIds.propertyPhotos, 'Photos'],
    [StepIds.propertyPromote, 'Promote'],
    [StepIds.propertySummary, 'Summary']
]);

export const SALE_TITLES_BY_STEP_ID: ReadonlyMap<StepIds, string> = new Map<
    StepIds,
    string
>([
    [StepIds.propertyInformation, 'Property Information'],
    [StepIds.propertyDescription, 'Property Description'],
    [StepIds.propertyPhotos, 'Photos'],
    [StepIds.propertyPromote, 'Promote'],
    [StepIds.propertySummary, 'Summary']
]);

export const getPropertyTitleByStepIdAndCategory = (
    s: StepIds,
    c: CategoryEnum
): string => {
    switch (c) {
        case CategoryEnum.residentialForRent:
            return RENT_TITLES_BY_STEP_ID.get(s);
        case CategoryEnum.residentialForSale:
        case CategoryEnum.newHomesHouseAndLand:
        case CategoryEnum.newHomesNewApartment:
        case CategoryEnum.newHomesNewHouse:
        case CategoryEnum.newHomesNewTownhouseAndTerraced:
        case CategoryEnum.rural:
            return SALE_TITLES_BY_STEP_ID.get(s);
        default:
            return '';
    }
};
